"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", null, [
        (_ctx.item.isSuperscript === true)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                key: 0,
                class: (0, vue_1.normalizeClass)(_ctx.classes)
            }, [
                (0, vue_1.createElementVNode)("sup", null, (0, vue_1.toDisplayString)(_ctx.content), 1)
            ], 2))
            : ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                key: 1,
                class: (0, vue_1.normalizeClass)(_ctx.classes)
            }, (0, vue_1.toDisplayString)(_ctx.content), 3))
    ]));
}
